export default{
    // @Partner
    newCreatedPartner:(state) =>{
        return state.newCreatedPartner
    }
}